import { jsxs, Fragment, jsx } from "react/jsx-runtime";
import { Box, Columns, Column, Text, Strong, TextLink } from "braid-design-system";
import { oauth } from "@seek/oauth-url-builders";
import { outer, csToggle } from "./ImpersonationBanner.css.mjs";
const actorDisplayText = (email) => {
  let displayText = "Operator";
  if (email && email.indexOf("@") > -1) {
    displayText = email.substring(0, email.indexOf("@"));
  }
  return displayText;
};
const actAsDisplayText = (email, additionalInfo) => /* @__PURE__ */ jsxs(Fragment, { children: [
  email,
  additionalInfo ? /* @__PURE__ */ jsxs(Fragment, { children: [
    " ",
    /* @__PURE__ */ jsxs("span", { children: [
      "(",
      additionalInfo,
      ")"
    ] })
  ] }) : null
] });
const getToggleButtonProps = (showCustomerServiceView, email) => {
  const scope = [`act:${email}`];
  if (!showCustomerServiceView) {
    scope.push("cs_view");
  }
  const returnUri = typeof window !== "undefined" ? window.location.pathname + window.location.search : void 0;
  const href = oauth.buildLoginWithScopeUrl({
    origin: "",
    realm: "seek-okta-global",
    returnUri,
    scope
  });
  const text = showCustomerServiceView ? "Switch to user view" : "Switch to CS view";
  return { href, text };
};
const ImpersonationBanner = ({ context, additionalInfo }) => {
  if (!(context == null ? void 0 : context.actor)) {
    return null;
  }
  const actor = actorDisplayText(context.actor.email);
  const actAs = actAsDisplayText(context.subject.email, additionalInfo);
  const toggleButtonProps = getToggleButtonProps(
    context.showCustomerServiceView || false,
    context.subject.email
  );
  return /* @__PURE__ */ jsx(
    Box,
    {
      paddingX: "gutter",
      background: "brandAccent",
      alignItems: "center",
      paddingY: "small",
      textAlign: "center",
      className: outer,
      children: /* @__PURE__ */ jsxs(
        Columns,
        {
          space: "small",
          collapseBelow: "tablet",
          alignY: "center",
          align: "center",
          children: [
            /* @__PURE__ */ jsx(Column, { width: "content", children: /* @__PURE__ */ jsxs(Text, { size: "small", children: [
              /* @__PURE__ */ jsx(Strong, { children: actor }),
              " is impersonating ",
              actAs
            ] }) }),
            /* @__PURE__ */ jsx(Column, { width: "content", children: /* @__PURE__ */ jsx(Text, { size: "small", weight: "medium", children: /* @__PURE__ */ jsx(TextLink, { href: toggleButtonProps.href, children: /* @__PURE__ */ jsx(
              Box,
              {
                display: "inlineBlock",
                paddingX: "small",
                paddingY: "xxsmall",
                marginLeft: "small",
                className: csToggle,
                children: toggleButtonProps.text
              }
            ) }) }) })
          ]
        }
      )
    }
  );
};
export {
  ImpersonationBanner
};
